<section class="wrapper">
        <img src="/assets/img/channels/integration-error.svg"/>
        <h1 class="title" translate>IVR.NOT_AVAILABLE.TITLE</h1>
        <p class="subtitle" translate>IVR.NOT_AVAILABLE.TEXT</p>
        <a
          mat-raised-button
          color="primary-full"
          routerLink="/choose-plan"
        >
          <span translate>IVR.NOT_AVAILABLE.UPGRADE_ACCOUNT</span>
        </a>

</section>
